import type {ReactElement} from 'react';
import {noop} from '@Utils/general.util';
import type {ColorStorage} from '@Components/color-picker-v2';
import {ColorPicker} from '@Components/color-picker-v2';
import {onAddBrandAssetClickedHandler} from '@Components/poster-editor/library/poster-editor-library';
import type {StylesPanelColorPickerSectionProps} from './styles-panel-color-picker-section.types';
import styles from './styles-panel-color-picker-section.module.scss';
import {hexToRgba, hextToHexString, rgbaToHex} from '@Utils/color.util';

export function StylesPanelColorPickerSection({selectedColor, onColorHexChange}: StylesPanelColorPickerSectionProps): ReactElement<any> {
  const onChangeColorEnded = (colors: ColorStorage[]): void => {
    onColorHexChange(hextToHexString(rgbaToHex(colors[0].color, false)));
  };

  const onAddBrandAssetBtnClick = (): void => {
    void onAddBrandAssetClickedHandler(true);
  };

  return (
    <div className="flex-v-row _full-width">
      <ColorPicker
        id="styles-panel-color-picker"
        className={styles.colorPicker}
        color={[{id: '', color: hexToRgba(selectedColor)}]}
        onMyDesign={[]}
        onChangeColor={noop}
        onChangeEnded={onChangeColorEnded}
        showOnMyDesignsSection={false}
        showPicker={false}
        onAddBrandAssetClicked={onAddBrandAssetBtnClick}
        isGradientEnabled={false}
        isAlphaDisabled
      />
    </div>
  );
}
